import React from 'react'
import BaseIcon from 'react-icon-base'

const PH = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>PH</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <g transform="translate(1)">
          <path fill="#0038A8" d="M.05.05h29.801v14.901H.05z" />
          <path fill="#CE1126" d="M.05 7.5h29.801v7.45H.05z" />
          <path fill="#FFF" d="M13 7.5L0 15V0" />
          <circle cx="4.685" cy="7.5" r="1.49" fill="#FCD116" />
          <path
            fill="#FCD116"
            d="M1.54 7.5l.193.194L4.685 7.5l-2.952-.194zM1.87 7.87l.159.158L4.686 7.5zM1.87 7.13l.159-.158 2.657.528z"
          />
          <path
            fill="#FCD116"
            d="M2.461 5.276v.273L4.685 7.5l-1.95-2.224zM2.433 5.772v.223L4.685 7.5zM2.957 5.248h.224L4.685 7.5zM4.685 4.354l-.193.194.193 2.952.194-2.952z"
          />
          <path fill="#FCD116" d="M4.315 4.685l-.158.158.528 2.657z" />
          <path
            fill="#FCD116"
            d="M5.056 4.685l.158.158L4.685 7.5zM6.91 5.276h-.274L4.686 7.5 6.91 5.55zM6.414 5.248H6.19L4.685 7.5z"
          />
          <path
            fill="#FCD116"
            d="M6.938 5.772v.223L4.685 7.5zM7.831 7.5l-.193-.194-2.953.194 2.953.194zM7.5 7.13l-.158-.158-2.657.528zM7.5 7.87l-.158.158L4.685 7.5zM6.91 9.724v-.273L4.685 7.5l1.951 2.224zM6.938 9.228v-.223L4.685 7.5zM6.414 9.752H6.19L4.685 7.5zM4.685 10.646l.194-.194L4.685 7.5l-.193 2.952zM5.056 10.315l.158-.158L4.685 7.5z"
          />
          <path
            fill="#FCD116"
            d="M4.315 10.315l-.158-.158.528-2.657zM2.461 9.724h.274L4.685 7.5 2.461 9.45zM2.957 9.752h.224L4.685 7.5zM2.433 9.228v-.223L4.685 7.5zM.399 2.23l.588.073.135.577.252-.536.59.05-.432-.406.23-.546-.519.286-.448-.388.111.582zM.399 12.77l.507.308-.111.582.448-.388.52.286-.23-.546.432-.406-.59.05-.253-.536-.135.577zM9.966 7.013l.339.487-.339.487.568-.172.358.472.012-.592.56-.195-.56-.195-.012-.592-.358.472z"
          />
        </g>
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default PH
